export default __webpack_public_path__ + "static/media/about-us.7c2036e4.webp";